import ModalOffre from "../../../user/listofferjunior/modaloffre/ModalOffre";

const PreviewOffer = ({ id_offer }) => {
  return (
    <ModalOffre id_offre={id_offer} endpoint={"user/offre"} preview={true} />
  );
};

export default PreviewOffer;
